import axios from 'axios';
//import moment from 'moment';
export const globalF = {
  methods: {
    setAxios: async function (from) {
      let website = this.$store.getters.getWebsite;
      let token = localStorage.getItem(website);
      if (token && token.length === 64) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        let p = await axios.post(this.url, {request: "getUserInfo" }, { headers: {'Content-Type': 'application/json'}})
            .then((response)  => {
                this.spinner = false;
                if (response.data.status === 0) {
                  this.$store.commit("addUser", response.data.user); 
                  this.$store.commit("addBuildings", response.data.buildings); 
                  this.$store.commit("addApplicantsType", response.data.applicantsType);
                  this.$store.commit("addPublicUnits", response.data.publicUnits); 
                  this.$store.commit("addInclusions", response.data.inclusions);
                  this.$store.commit("addOtherServices", response.data.otherServices);
                  this.$store.commit("addCreditStatus", response.data.creditStatus);
                  this.$store.commit("addProcess", response.data.process);
                  this.$store.commit("addProcessEndorser", response.data.endorserProcess);
                  this.$store.commit("addProspectsUnits", response.data.propectsUnits);
                  this.$store.commit("addProspectSession", response.data.propectSession);

                  if (from === 'ApplicationsProcess') {                    
                    let processData = response.data.process;
                    if (processData && processData.length > 0) {
                      return processData;            
                    }
                  }

                  if (from === 'EndorserProcess') {     
                    let myObj = {};               
                    let endData = response.data.endorserProcess;
                    if (endData && endData.length > 0) {
                      myObj.endData = endData;            
                    }
                    let processData = response.data.process;
                    if (processData && processData.length > 0) {
                      myObj.processData = processData;            
                    }
                    return myObj;
                  }
                }
            })
            .catch(()  => {
              let website = this.$store.getters.getWebsite;
              localStorage.removeItem(website);
              window.location.reload();
            });

          return p;
      }
      
    },
    formatBselect : function(list, lg) {
      let arr = [];
      for (let i = 0; i < list.length; i++) { 
          let options = {};
          options.value = list[i].Id;
          options.text = lg === 'fr' ? list[i].fr : list[i].en;
          arr.push(options);
      }
      return arr;
    },
    formatPublicUnits(publicUnits) {
      
      let allUnits = [];
      if (publicUnits.length > 0) {
        for (let i = 0; i < publicUnits.length; i++) {
          let publicUnitsObj = publicUnits[i];
            if (publicUnitsObj.hasOwnProperty("Data")) {
              let parseData = false;
              try {
                parseData = JSON.parse(publicUnitsObj.Data);
              }
              catch (error) {
                console.log(error);
              }

              if (parseData.length > 0) {
                for (let i = 0; i < parseData.length; i++) {
                  allUnits.push(parseData[i]);
                }
              }
            }
          }

        }

      return allUnits;
  },
  getQueryStringValue() {
    
    let queryStringVal = this.getSelectedFromQueryString();
    let publicUnits = this.$store.getters.getPublicUnits;
    let allUnits = this.formatPublicUnits(publicUnits);

    let find = [];

    if (queryStringVal.hasOwnProperty('floorPlan') && queryStringVal.hasOwnProperty('propertyCode')) {

      for (let i=0; i < allUnits.length; i ++) {
        let fp = allUnits[i].floorPlanInfo;
        if (fp) {
          if (fp.FloorPlan.trim() === queryStringVal.floorPlan && fp.PropertyCode.trim() === queryStringVal.propertyCode) {
            find.push(allUnits[i]);
          }
        }
      }
    }

    if (queryStringVal.hasOwnProperty('NOCIE') && queryStringVal.hasOwnProperty('NODIV')) {
      find = allUnits.filter(u => u.NOCIE === queryStringVal.NOCIE && u.NODIV === queryStringVal.NODIV);
    }

    return find;
  },
  getSelectedFromQueryString() {
      let value = localStorage.getItem("BuildingUnit");
      let buildingUnit = []
      if (value) {
        buildingUnit = JSON.parse(value);
      }
      return buildingUnit;
    }
  }
};